import {useCallback} from 'react'

import PropTypes from 'prop-types'

import CardRating from '@adv-mt/mt-card-rating'

import {BASE_CLASS, DATE_FORMAT_LOCALE, DATE_FORMAT_OPTIONS, NO_OP} from './config.js'

const formatRatingDate = date => new Date(date).toLocaleDateString(DATE_FORMAT_LOCALE, DATE_FORMAT_OPTIONS)

const ListRatings = ({isOwner, onReply = NO_OP, onReport = NO_OP, ratings = []}) => {
  const handleReply = useCallback(
    ({id, text}) => {
      onReply({id, text})
    },
    [onReply]
  )

  const handleReport = useCallback(
    ({id}) => {
      onReport({id})
    },
    [onReport]
  )

  return (
    <div className={BASE_CLASS}>
      {ratings.map(rating => (
        <CardRating
          key={rating.feedback.feedbackId}
          id={rating.feedback.feedbackId}
          isOwner={isOwner}
          onReply={handleReply}
          onReport={handleReport}
          rating={rating.feedback.score * 5}
          ratingTargetName={rating.feedback.reply?.authorName}
          replyDate={formatRatingDate(rating.feedback.reply?.givenAt)}
          replyMessage={rating.feedback.reply?.text}
          reviewDate={formatRatingDate(rating.feedback.givenAt)}
          reviewerName={rating.name}
          reviewText={rating.feedback.textReview}
          showReplyAction={rating.feedback.replyAllowed}
          showReportAction={rating.feedback.reportAllowed}
          tags={(rating.feedback.options || []).filter(option => option.selected).map(option => option.title)}
          categories={rating.categories}
        />
      ))}
    </div>
  )
}

const ListRatingsPrimitive = ({
  isOwner,
  notificationContent = NO_OP,
  onReply = NO_OP,
  onReport = NO_OP,
  ratings = []
}) => {
  const handleReply = useCallback(
    ({id, text}) => {
      onReply({id, text})
    },
    [onReply]
  )

  const handleReport = useCallback(
    ({id}) => {
      onReport({id})
    },
    [onReport]
  )

  return (
    <div className={BASE_CLASS}>
      {notificationContent}
      {ratings.map((rating, index) => (
        <CardRating
          isOwner={isOwner}
          key={rating?.id || `card-rating-${index}`}
          onReply={handleReply}
          onReport={handleReport}
          {...rating}
        />
      ))}
    </div>
  )
}

ListRatings.displayName = 'ListRatings'

ListRatings.propTypes = {
  isOwner: PropTypes.bool,
  onReply: PropTypes.func,
  onReport: PropTypes.func,
  ratings: PropTypes.array
}

ListRatingsPrimitive.displayName = 'ListRatingsPrimitive'

ListRatingsPrimitive.propTypes = {
  isOwner: PropTypes.bool,
  notificationContent: PropTypes.node,
  onReply: PropTypes.func,
  onReport: PropTypes.func,
  ratings: PropTypes.array
}

export default ListRatings

export {ListRatingsPrimitive}
